import { SalaryRow, SalarySummaryRow } from ".";
import { SalaryDashboardData } from "./Dashboard";

export const rawData: SalaryRow[] = [
  {
    personnel_code: "2482",
    personnel_name: "Nguyễn Trí",
    position_title: "Nhân viên kinh doanh",
    date_join: "2025-12-01",
    salary_type_cb: 9000000,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 9400000,
    allow_170: 40000,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 9040000,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 53571.4,
    luonggiocongchuan: 53809.5,
    cal_workday: 20,
    cal_workhour: 175,
    total_cal_workhour: 175,
    luong_gio_cong: 9416662.5,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 9416662.5,
    deduct_insurance: 945000,
    bhxh: 720000,
    bhyt: 135000,
    bhtn: 90000,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 8471662.5
  },
  {
    personnel_code: "HSNS_2023_1068",
    personnel_name: "Thanh Tâm",
    position_title: "Thư ký Dự án",
    date_join: "2023-09-01",
    salary_type_cb: 10000000,
    salary_type_luong_ca: 212,
    muc_luong_ca: 470000,
    luong_ca: 176250,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 10000000,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 59523.8,
    luonggiocongchuan: 59523.8,
    cal_workday: 0.375,
    cal_workhour: 3,
    total_cal_workhour: 3,
    luong_gio_cong: 178571.4,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 178571.4,
    deduct_insurance: 1050000,
    bhxh: 800000,
    bhyt: 150000,
    bhtn: 100000,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: -871428.6
  },
  {
    personnel_code: "HN_710",
    personnel_name: "Hồng Hạnh",
    position_title: "",
    date_join: "2025-09-11",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "HN_701",
    personnel_name: "Huy",
    position_title: "",
    date_join: "2025-09-10",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "1565",
    personnel_name: "Lâm Phan",
    position_title: "",
    date_join: "2025-10-25",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "HN_775",
    personnel_name: "Trần Phú",
    position_title: "",
    date_join: "2025-09-18",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "HN_702",
    personnel_name: "Sokkea",
    position_title: "",
    date_join: "2025-09-10",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "1Office.20",
    personnel_name: "Trần Phương Thảo",
    position_title: "Cố vấn Ban giám đốc",
    date_join: "2020-06-01",
    salary_type_cb: 30000000,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 11280000,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 30000000,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 178571.4,
    luonggiocongchuan: 178571.4,
    cal_workday: 24,
    cal_workhour: 192,
    total_cal_workhour: 192,
    luong_gio_cong: 34285708.8,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 34285708.8,
    deduct_insurance: 3150000,
    bhxh: 2400000,
    bhyt: 450000,
    bhtn: 300000,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 15635708.8,
    thue_tncn: 1063570.9,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 30072137.9
  },
  {
    personnel_code: "VJ_03",
    personnel_name: "Hiếu Dương",
    position_title: "Nhân viên QC",
    date_join: "2025-01-01",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "956",
    personnel_name: "Mạc Quế Hân",
    position_title: "(1Office) Chuyên viên Kinh doanh",
    date_join: "2022-11-08",
    salary_type_cb: 9000000,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 11456250,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 9000000,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 53571.4,
    luonggiocongchuan: 53571.4,
    cal_workday: 24.375,
    cal_workhour: 195,
    total_cal_workhour: 195,
    luong_gio_cong: 10446423,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 10446423,
    deduct_insurance: 864000,
    bhxh: 720000,
    bhyt: 135000,
    bhtn: 9000,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 9582423
  },
  {
    personnel_code: "00085",
    personnel_name: "Nguyễn Quốc Trung",
    position_title: "(1Office) Cố vấn cao cấp phát triển sản phẩm",
    date_join: "2010-01-01",
    salary_type_cb: 4750000,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 4750000,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 28273.8,
    luonggiocongchuan: 28273.8,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 498750,
    bhxh: 380000,
    bhyt: 71250,
    bhtn: 47500,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: -498750
  },
  {
    personnel_code: "VJ_02",
    personnel_name: "Phúc Trần",
    position_title: "Trưởng phòng QC",
    date_join: "2025-01-01",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "VJ_01",
    personnel_name: "Diễm Huỳnh",
    position_title: "Cố vấn Ban giám đốc",
    date_join: "2025-01-01",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  },
  {
    personnel_code: "HN_675",
    personnel_name: "Mr. Nam Nguyen",
    position_title: "Giám đốc vận hành",
    date_join: "2025-09-04",
    salary_type_cb: 0,
    salary_type_luong_ca: 0,
    muc_luong_ca: 470000,
    luong_ca: 0,
    allow_170: 0,
    allow_179: 0,
    allow_173: 0,
    allow_176: 0,
    tong_luong_phu_cap: 0,
    number_workday: 21,
    gio_cong_chuan: 168,
    luonggiocongchuan_kpc: 0,
    luonggiocongchuan: 0,
    cal_workday: 0,
    cal_workhour: 0,
    total_cal_workhour: 0,
    luong_gio_cong: 0,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 0,
    deduct_insurance: 0,
    bhxh: 0,
    bhyt: 0,
    bhtn: 0,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 15500000,
    deduct_total: 15500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 0,
    thue_tncn: 0,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 0
  }
];

export const mockSalarySummaryData: SalarySummaryRow[] = [
  {
    position_title: 'Giám đốc',
    total_employee: 1,
    salary_type_cb: 35000000,
    salary_type_luong_ca: undefined,
    muc_luong_ca: undefined,
    luong_ca: undefined,
    allow_170: 1000000,
    allow_179: 5000000,
    allow_173: 500000,
    allow_176: 1000000,
    tong_luong_phu_cap: 42500000,
    number_workday: 26,
    gio_cong_chuan: 208,
    luonggiocongchuan_kpc: 35000000,
    luonggiocongchuan: 42500000,
    cal_workday: 26,
    cal_workhour: 208,
    total_cal_workhour: 208,
    luong_gio_cong: 42500000,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 42500000,
    deduct_insurance: 3675000,
    bhxh: 2800000,
    bhyt: 525000,
    bhtn: 350000,
    number_dependent: 2,
    giamtrunguoiphuthuoc: 8800000,
    giamtrucanhan: 11000000,
    deduct_total: 23475000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 19025000,
    thue_tncn: 1603750,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 37221250,
  },
  {
    position_title: 'Trưởng phòng Nhân sự',
    total_employee: 1,
    salary_type_cb: 20000000,
    salary_type_luong_ca: undefined,
    muc_luong_ca: undefined,
    luong_ca: undefined,
    allow_170: 780000,
    allow_179: 2000000,
    allow_173: 500000,
    allow_176: 500000,
    tong_luong_phu_cap: 23780000,
    number_workday: 26,
    gio_cong_chuan: 208,
    luonggiocongchuan_kpc: 20000000,
    luonggiocongchuan: 23780000,
    cal_workday: 25,
    cal_workhour: 200,
    total_cal_workhour: 200,
    luong_gio_cong: 22865385,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 22865385,
    deduct_insurance: 2100000,
    bhxh: 1600000,
    bhyt: 300000,
    bhtn: 200000,
    number_dependent: 1,
    giamtrunguoiphuthuoc: 4400000,
    giamtrucanhan: 11000000,
    deduct_total: 17500000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 5365385,
    thue_tncn: 268269,
    tongtienphat: 50000,
    cal_fine_late: 50000,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 20447116,
  },
  {
    position_title: 'Lập trình viên Senior',
    total_employee: 3,
    salary_type_cb: 25000000,
    salary_type_luong_ca: undefined,
    muc_luong_ca: undefined,
    luong_ca: undefined,
    allow_170: 780000,
    allow_179: 0,
    allow_173: 500000,
    allow_176: 300000,
    tong_luong_phu_cap: 26580000,
    number_workday: 26,
    gio_cong_chuan: 208,
    luonggiocongchuan_kpc: 25000000,
    luonggiocongchuan: 26580000,
    cal_workday: 26,
    cal_workhour: 208,
    total_cal_workhour: 220,
    luong_gio_cong: 26580000,
    luongtangcathuong: 2300192,
    tongluongtangca: 2300192,
    tongluongtruocthue: 28880192,
    deduct_insurance: 2625000,
    bhxh: 2000000,
    bhyt: 375000,
    bhtn: 250000,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 11000000,
    deduct_total: 13625000,
    giamtrutangcathuong: 766731,
    tonggiamtrutangca: 766731,
    thunhaptinhthue: 14488461,
    thue_tncn: 1173269,
    tongtienphat: 0,
    cal_fine_late: 0,
    cal_fine_soon: 0,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 25081923,
  },
  {
    position_title: 'Nhân viên Chăm sóc khách hàng',
    total_employee: 5,
    salary_type_cb: 8000000,
    salary_type_luong_ca: 1,
    muc_luong_ca: 250000,
    luong_ca: 6500000,
    allow_170: 780000,
    allow_179: 0,
    allow_173: 500000,
    allow_176: 200000,
    tong_luong_phu_cap: 15980000,
    number_workday: 26,
    gio_cong_chuan: 208,
    luonggiocongchuan_kpc: 14500000,
    luonggiocongchuan: 15980000,
    cal_workday: 26,
    cal_workhour: 208,
    total_cal_workhour: 208,
    luong_gio_cong: 15980000,
    luongtangcathuong: 0,
    tongluongtangca: 0,
    tongluongtruocthue: 15980000,
    deduct_insurance: 840000,
    bhxh: 640000,
    bhyt: 120000,
    bhtn: 80000,
    number_dependent: 0,
    giamtrunguoiphuthuoc: 0,
    giamtrucanhan: 11000000,
    deduct_total: 11840000,
    giamtrutangcathuong: 0,
    tonggiamtrutangca: 0,
    thunhaptinhthue: 4140000,
    thue_tncn: 207000,
    tongtienphat: 100000,
    cal_fine_late: 50000,
    cal_fine_soon: 50000,
    cal_fine_leave_noreason: 0,
    cal_fine_no_checkinout: 0,
    final_salary: 14833000,
  },
];

export const DASHBOARD_DATA: SalaryDashboardData = {
  kpi: {
    totalSalaryCurrent: 46_756_045,
    totalSalaryChangePercent: -13.6,
    headcount: 14,
    headcountChange: 0,
    salaryPerHead: 3_339_717,
    annualRunRate: 561_072_538,
    comparePeriod: "07/2026",
  },
  composition: [
    { label: "Lương cơ bản", amount: 10_800_000, color: "#5B9BF0" },
    { label: "Phụ cấp", amount: 21_500_000, color: "#3A3A3A" },
    { label: "Bảo hiểm", amount: 2_244_000, color: "#8BC98A" },
    { label: "Thuế TNCN", amount: 12_212_045, color: "#F0A75B" },
  ],
  byDepartment: [
    { name: "Ban cố vấn", value: 38_100_000 },
    { name: "[TTP] Công ty TTP", value: 7_900_000 },
    { name: "Ban Thư ký Tổng Giám Đốc", value: -240_000 },
  ],
  byPosition: [
    { name: "Cố vấn Ban giám đốc", value: 29_800_000 },
    { name: "(1Office) Chuyên vi...", value: 7_900_000 },
    { name: "Nhân viên kinh doanh", value: 7_600_000 },
    { name: "(1Office) Cố vấn ca...", value: -180_000 },
    { name: "Thư ký Dự án", value: -1_100_000 },
  ],
  byRole: [
    { name: "#273", value: 29_800_000 },
    { name: "(1Office) Chuyên viên", value: 7_900_000 },
    { name: "(N) Nhân viên", value: 7_800_000 },
    { name: "Thư ký", value: 900_000 },
  ],
  totalSalaryTrend: [
    { period: "01/2026", value: 52_800_000 },
    { period: "02/2026", value: 44_600_000 },
    { period: "03/2026", value: 35_000_000 },
    { period: "04/2026", value: 61_000_000 },
    { period: "05/2026", value: 60_900_000 },
    { period: "06/2026", value: 58_200_000 },
    { period: "07/2026", value: 54_100_000 },
    { period: "08/2026", value: 46_756_045 },
  ],
  headcountTrend: [
    { period: "01/2026", value: 15 },
    { period: "02/2026", value: 14 },
    { period: "03/2026", value: 15 },
    { period: "04/2026", value: 15 },
    { period: "05/2026", value: 15 },
    { period: "06/2026", value: 15 },
    { period: "07/2026", value: 14 },
    { period: "08/2026", value: 14 },
  ],
  avgSalaryTrend: [
    { period: "01/2026", value: 3_520_000 },
    { period: "02/2026", value: 3_190_000 },
    { period: "03/2026", value: 2_470_000 },
    { period: "04/2026", value: 4_070_000 },
    { period: "05/2026", value: 4_060_000 },
    { period: "06/2026", value: 3_880_000 },
    { period: "07/2026", value: 3_860_000 },
    { period: "08/2026", value: 3_339_717 },
  ],
  yoyGrowth: [],
};
